export default function objectKeysToLowerCase(obj: any) {
    if (!obj)
        return obj;

    return Object.keys(obj)
        .reduce((acc: any, key) => {
            acc[key.toLowerCase()] = obj[key];
            return acc;
        }, {});
}
